import { combineReducers, configureStore } from '@reduxjs/toolkit'
import fileUploadReducer from './reduxSlice/fileUploadSlice';

const rootReducer = combineReducers({
    fileUpload: fileUploadReducer,
});

export const store = configureStore({
    reducer: rootReducer,
});